<template>
    <div class="review-block">
        <div class="row q-n-a question">
            <div class="icon">Q</div>
            <div class="text">{{ data.question }}</div>
        </div>
        <div
            v-for="(option, i) in data.options"
            :key="`option${i}`"
            class="row q-n-a answer"
            :class="{ true: data.answer === i }"
        >
            <div class="icon">{{ letterIndex(i) }}</div>
            <div class="text">
                {{ option }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: Object,
    },
    methods: {
        letterIndex(index) {
            const LETTERS = ['A', 'B', 'C', 'D'];
            return LETTERS[index];
        },
    },
};
</script>

<style lang="scss" scoped>
.review-block {
    font-weight: bold;
    width: 90%;
    margin: 15px auto;
    border-bottom: 1px solid #57a2e7;
    .icon {
        font-size: 18px;
        margin-right: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        width: 30px;
        height: 30px;
        color: #fff;
    }
    .row {
        display: flex;
        margin-bottom: 10px;
    }
    .q-n-a {
        font-size: 20px;
        .text {
            flex: 1;
        }
    }
    .question .icon {
        background-color: #57a2e6;
    }

    .answer {
        .icon {
            background-color: #bbb;
        }
        &.true {
            color: #5ac892;
            .icon {
                background-color: #5ac892;
            }
        }
    }
}
</style>
